import { CallHandler, ExecutionContext, Injectable, NestInterceptor } from '@nestjs/common';
import { isEmpty } from 'lodash';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { WinstonLogger } from '../loggers';

@Injectable()
export class LoggingInterceptor implements NestInterceptor {
  constructor(private readonly winstonLogger: WinstonLogger) {
    this.winstonLogger.setContext(LoggingInterceptor.name);
  }

  public intercept(context: ExecutionContext, next: CallHandler): Observable<any> {
    const { method, originalUrl } = context.switchToHttp().getRequest();
    const start = process.hrtime.bigint();
    return next.handle().pipe(
      tap((data) => {
        const { statusCode } = context.switchToHttp().getResponse();
        const contentLength = isEmpty(data) ? 0 : Buffer.byteLength(JSON.stringify(data), 'utf8');
        const end = process.hrtime.bigint();
        const responseTime = Number((end - start) / 1_000_000n).toFixed(3);
        this.winstonLogger.log(`${method} ${originalUrl} ${statusCode} ${responseTime} ms - ${contentLength}`);
      })
    );
  }
}
